export default __webpack_public_path__ + "static/property-img-2_768-44805ba792f85a99e20213c69073c987.jpg";